// import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

const outerHeight = window.outerHeight;
if (!browser.versions.ios) {
  window.onresize = () => {
    if (window.outerHeight < outerHeight) {
      this.a.commit("Set_WindowChange", true);
    } else {
      this.a.commit("Set_WindowChange", false);
    }
  }

}
/*Vuex.Store实例化*/
const store = new Vuex.Store({
  /*state在vuex中用于存储数据*/
  state: {
    transition: true,
    showDataScreen: false,
    windowChange: false,
  },
  /*mutations里面是放的是方法，主要用于改变stare里面的数据*/
  mutations: {
    ["Set_Transition"](state, data) {
      state.transition = data;
    },
    ["Set_DataScreen"](state, data) {
      state.showDataScreen = data;
    },
    ["Set_WindowChange"](state, data) {
      state.windowChange = data;
    },
  },
  /*getters计算属性*/
  getters: {

  },
  /*getters动态方法，需调用mutations方法更新state状态*/
  actions: {

  },
})
export default store;




// WEBPACK FOOTER //
// ./src/vuex/store.js